import { Endpoint } from './common'
import {
	createMutation,
	EnhancedMutationApi,
	MutationConfig,
	useBaseAddLineItem,
	useBaseCreateOrder,
	useBaseUpdateLineItem,
	useBaseUpdateProductQuantity
} from './react-query'

export const useCreateOrder = <Subscribe extends boolean = true>(
	subscribe: Subscribe = true as Subscribe,
	config?: MutationConfig<Endpoint.CreateOrder>
): EnhancedMutationApi<Endpoint.CreateOrder, Subscribe> => useBaseCreateOrder<Subscribe>(subscribe, config)

export const useAddItemToOrder = <Subscribe extends boolean = true>(
	subscribe: Subscribe = true as Subscribe,
	config?: MutationConfig<Endpoint.AddLineItem>
): EnhancedMutationApi<Endpoint.AddLineItem, Subscribe> =>
	useBaseAddLineItem<Subscribe>(
		subscribe,
		config,
		createMutation<Endpoint.AddLineItem, Endpoint.GetOrder>(Endpoint.GetOrder, ({ path: { orderUuid } }) => ({
			path: { orderUuid }
		}))
	)

export const useUpdateProductQuantity = <Subscribe extends boolean = true>(
	subscribe: Subscribe = true as Subscribe,
	config?: MutationConfig<Endpoint.UpdateProductQuantity>
): EnhancedMutationApi<Endpoint.UpdateProductQuantity, Subscribe> =>
	useBaseUpdateProductQuantity<Subscribe>(
		subscribe,
		config,
		createMutation<Endpoint.UpdateProductQuantity, Endpoint.GetOrder>(
			Endpoint.GetOrder,
			({ path: { orderUuid } }) => ({ path: { orderUuid } })
		)
	)

export const useUpdateLineItem = <Subscribe extends boolean = true>(
	subscribe: Subscribe = true as Subscribe,
	config?: MutationConfig<Endpoint.UpdateLineItem>
): EnhancedMutationApi<Endpoint.UpdateLineItem, Subscribe> =>
	useBaseUpdateLineItem<Subscribe>(
		subscribe,
		config,
		createMutation<Endpoint.UpdateLineItem, Endpoint.GetOrder>(Endpoint.GetOrder, ({ path: { orderUuid } }) => ({
			path: { orderUuid }
		}))
	)
